<div
    class="insight-persist"
    *ngIf="!disallowSetDefault || !disallowSetFavourite"
>
    <button
        type="button"
        class="btn bg-transparent pr-0 pl-0 mr-3 cmps-cdk-py-0dot5"
        [disabled]="disallowSetDefault"
        (click)="defaultClick.emit(!isDefault)"
    >
        {{ _i18n._7151_DEFAULT | translate }}&nbsp;
        <cmps-icon
            class="cmps-cdk-fill-green-100"
            svgIcon="check"
            *ngIf="isDefault"
        ></cmps-icon>
    </button>
    <button
        type="button"
        class="btn bg-transparent pr-0 pl-0 cmps-cdk-py-0dot5"
        [disabled]="disallowSetFavourite"
        (click)="favouriteClick.emit(!isFavourite)"
    >
        {{ _i18n._7152_FAVOURITE | translate }}&nbsp;
        <cmps-icon
            class="cmps-cdk-fill-yellow-100"
            svgIcon="star"
            *ngIf="isFavourite"
        ></cmps-icon>
    </button>
</div>
